import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResetLayoutComponent} from './reset-layout.component';
import {FlexModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';


@NgModule({
    declarations: [
        ResetLayoutComponent
    ],
    exports: [
        ResetLayoutComponent
    ],
    imports: [
        FlexModule,
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressBarModule,
    ]
})
export class ResetLayoutModule {
}
